import { render } from "./lightbox-vm18.vue?vue&type=template&id=245b426c"
import script from "./lightbox-vm18.vue?vue&type=script&lang=js"
export * from "./lightbox-vm18.vue?vue&type=script&lang=js"

import "./lightbox-vm18.vue?vue&type=style&index=0&id=245b426c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__